import React from 'react';
import styled from '@emotion/styled';
import Slider from 'react-slick';

import { FOCUS } from '../../constants';

const common = `
  background-color: white;
  padding: 1px 40px;
  border-radius: 8px;
  border: solid 1px #aaa;
`;

export const StyledWordsSlider = styled.div`
  ${common};
  max-width: 626px;
`;

export const StyledWordsSliderWrapper = styled.div`
  margin: 0 auto;
  width: 926px;
`;

export const StyledSliderWordContainer = styled.div`
  padding: 2px 10px;
`;

export const StyledSliderWord = styled.span<{ hoverColor: string }>`
  font-size: 12px;
  padding: 0 5.5px;
  cursor: pointer;

  &:hover {
    background-color: ${({ hoverColor }) => hoverColor};
  }
`;

export const StyledWordsPicker = styled.div`
  ${common};

  padding: 1px 20px;
  display: flex;
  width: fit-content;
`;
// @ts-ignore

export const StyledSlider = styled(({ ...rest }) => <Slider {...rest} />)`
  .slick-prev {
    left: -30px;
    display: block;
  }

  .slick-next {
    right: -30px;
    display: block;
  }

  .slick-prev:before,
  .slick-next:before {
    content: '' !important;
  }
`;

export const StyledSliderArrow = styled.div`
  display: flex !important;
  position: absolute !important;
  justify-content: center;
  align-items: center;
  ${FOCUS};
  z-index: 20;
`;
